import React, { useState, useEffect } from 'react';
import { apiUrl } from '../../UploadDocument/apiUrl';

const DicomSenderAll = ({ isOpen }) => {
  // Nota: Eliminé 'iconProps' de las props ya que no lo estabas usando correctamente,
  // y definimos todo el estilo del icono directamente aquí.

  // Estado para gestionar si el botón está activado o no
  const [isActive, setIsActive] = useState(false);

  // 1. Clases de diseño adaptadas del Sidebar
  const commonButtonClass =
    'flex hover:bg-primary-main justify-start justify-items-center rounded p-1 w-full text-white my-2';

  // Clase para ocultar o mostrar el texto
  const textVisibilityClass = isOpen ? '' : 'hidden';

  // Clases condicionales de color
  const activeBgClass = isActive
    ? 'bg-green-600 hover:bg-green-700' // Activo (Verde)
    : 'bg-red-600 hover:bg-red-700';   // Inactivo (Rojo)

  // Cálculo de las dimensiones dinámicas del icono: 25px abierto, 15px cerrado.
  const dynamicIconSize = isOpen ? '25' : '15';

  // Función para hacer el GET y verificar el estado actual de "isActive"
  const fetchState = async () => {
    try {
      const response = await fetch(apiUrl + '/api/dicom/findActivate');
      const data = await response.json();
      if (data && data.isActive !== undefined) {
        setIsActive(data.isActive);
      }
    } catch (error) {
      console.error('Error al obtener el estado:', error);
    }
  };

  // Función para cambiar el estado al hacer clic en el botón
  const toggleState = async () => {
    try {
      const newState = !isActive;
      const response = await fetch(apiUrl + '/api/dicom/findActivate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ isActive: newState }),
      });

      if (response.ok) {
        setIsActive(newState);
      } else {
        console.error('Error al cambiar el estado');
      }
    } catch (error) {
      console.error('Error al enviar el estado:', error);
    }
  };

  // Usamos useEffect para verificar el estado cuando el componente se monta
  useEffect(() => {
    fetchState();
  }, []);
  // ----------------------------------------

  return (
    <button
      onClick={toggleState}
      // Combinamos las clases base, las de color, y la transición
      className={`${commonButtonClass} ${activeBgClass} transition-colors duration-200 my-2`}
    >
      {/* Icono SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // Propiedades de tamaño dinámico
        width={dynamicIconSize}
        height={dynamicIconSize}
        // Clase combinada: color blanco + no encoger
        className='text-white flex-shrink-0'
        viewBox="0 0 16 16"
        fill="currentColor" // Asegura que los paths usen el color de texto
      >
        <path
          fillRule="evenodd"
          d="M15.854.146a.5.5 0 0 1 .11.54l-2.8 7a.5.5 0 1 1-.928-.372l1.895-4.738-7.494 7.494 1.376 2.162a.5.5 0 1 1-.844.537l-1.531-2.407L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM5.93 9.363l7.494-7.494L1.591 6.602z"
        />
        <path
          fillRule="evenodd"
          d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708z"
        />
      </svg>

      {/* Texto - visible solo si el sidebar está abierto */}
      <span className={`ml-3 whitespace-nowrap overflow-hidden ${textVisibilityClass}`}>
        Envio {isActive ? 'activo' : 'inactivo'}
      </span>

    </button>
  );
};

export default DicomSenderAll;
